import { createFileRoute } from "@tanstack/react-router";
import HttpRequestBuilderPage from "@/pages/HttpRequestBuilderPage";

export const Route = createFileRoute("/tools/http-request-builder")({
  component: HttpRequestBuilderPage,
});
